import { render } from "./RoleRow.vue?vue&type=template&id=b9873c1e"
import script from "./RoleRow.vue?vue&type=script&lang=js"
export * from "./RoleRow.vue?vue&type=script&lang=js"

import exportComponent from "/Users/bertog/Code/aitmes/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__